import React from 'react';
import Header from '../Header/Header';
import Footer from './Footer';

const Returns = () => {
    return (
        <>
            <Header />
            <div className="returns-container" style={{ padding: '2rem', lineHeight: '1.8', fontFamily: 'Arial, sans-serif', margin: 'auto', maxWidth: "1200px" }}>
                <h1><strong>Returns :</strong></h1>

                <p>We offer a <strong>100% no quibble money back guarantee</strong>. If you are not satisfied with any of our products that you have purchased from us, we will give you a 100% refund (excluding delivery charge and gift-wrapping where appropriate).</p>

                <p>Returns for refund must be received back into the warehouse within <strong>30 days</strong> from the date of purchase. When returning goods, please quote the order number, your name, name of the product, and the reason why you are returning the goods.</p>

                <h7><strong>How do customers request a return? :</strong></h7>
                <p>Customers can communicate their return requests to us through an email to <a href="mailto:onlinesales@shreenathfoods.com">onlinesales@shreenathfoods.com</a> or by phone at <strong>+91 7075719299</strong>.</p>

                <h7><strong>What if there’s a delay in the post and the goods reach after 30 days?</strong></h7>
                <p>We issue a no-quibble refund or replacement for products that are received back in our warehouse within 30 days. In case of shipments reaching us after 30 days due to unavoidable reasons such as postal delays, we handle the situation on a case-by-case basis.</p>

                <h7><strong>Where should returns be sent? :</strong></h7>
                <address>
                    <strong>GloCart</strong><br />
                    6-3-10/2, Behind Vimal Theater, Balanagar,<br />
                    Hyderabad, Telangana 500042<br />
                    India.
                </address>

                <h7><strong>Do you refund postage expenses for returns? :</strong></h7>
                <p>No. We do not refund users for postage expenses incurred for returning goods.</p>

                <h7><strong>Replacement Guarantee :</strong></h7>
                <p>We offer a 100% no quibble money back guarantee. If you are not satisfied with any of our products that you have purchased from us, we will give you a 100% refund (excluding delivery charge and gift-wrapping where appropriate).</p>

                <p>Returns for refund must be received back into the warehouse within 30 days from the date of purchase. When returning goods, please quote the order number, your name, name of the product, and the reason for returning the goods.</p>

                <p>In a few cases, we ensure that pickup is arranged at the earliest and we ship the replacement as soon as we receive the item from our courier partner. Replacement is subject to availability of stock with us. In case a replacement is not available, we will refund the amount.</p>

                <h7><strong>When are returns not possible? :</strong></h7>
                <ul>
                    <li>Used products</li>
                    <li>Return request is made outside the specified time frame</li>
                    <li>Products with tampered or missing serial numbers, including price tags and labels</li>
                </ul>

                <h7><strong>Can I return part of my order? :</strong></h7>
                <p>Yes, returns are possible at item level. If you have ordered multiple items, you can request a return for a partial quantity. However, shipment charges for the same need to be borne by the customer. Returns must be received back into the warehouse within 30 days from the date of purchase.</p>

                <h7><strong>When are refunds provided? :</strong></h7>
                <p>Refunds are provided only in cases of damage in transit or when we cannot provide a replacement due to lack of stock. In case of returns, a refund is issued once the products are received at our warehouse.</p>

                <h7><strong>When will I receive my replacement? :</strong></h7>
                <p>Replacement will be sent to customers once the returned products are received and the courier details are shared with us. Replacements typically reach customers within <strong>5–7 working days</strong> from the date of shipment.</p>

                <h7><strong>Exchange Policy :</strong></h7>
                <p>Exchange of unused products must be communicated within 30 days and must reach our warehouse within 30 days from the date of shipment of the original order. Shipment charges for exchanges must be borne by the customer. Customers need to share courier details of the products they intend to exchange with us. The replacement parcels will reach customers within <strong>5–7 working days</strong> from the date of shipment.</p>
            </div>
            <Footer />
        </>
    );
}

export default Returns;
